---
title: Configurazione email e casella di posta
parent: Documentazione
parentHref: /docs
---

# Configurazione della casella di posta elettronica

Il Suo piano TOBY include un indirizzo email professionale corrispondente al Suo dominio (ad esempio, info@suo-dominio.de) con una **casella di posta da 15 GB (Maxi-Postfach)**, oltre a indirizzi di inoltro email illimitati. Ha bisogno di più caselle di posta o spazio di archiviazione aggiuntivo? Può aggiungere un'altra casella da 15 GB in qualsiasi momento — consulta il [listino prezzi](/it/pricing).

## 1. Creare la casella di posta in TOBY

1. Apra **Impostazioni → Email** in TOBY.
2. Scelga l'indirizzo che desidera (come info@, hello@ o contact@) e crei la casella di posta.
3. **Copi la password:** TOBY mostra la password generata della casella di posta una sola volta subito dopo la creazione. La copi o la salvi prima di chiudere la finestra. (Se dovesse perderla, può generare una nuova password con un clic in **Impostazioni → Email** — le email esistenti rimangono al sicuro.)

## 2. Leggere e inviare email nel browser (Webmail)

Può aprire la Sua casella di posta da qualsiasi browser di computer o smartphone senza installare un'app:

- **Indirizzo Webmail:** [mail.tobysite.com/SOGo](https://mail.tobysite.com/SOGo)
- **Nome utente:** il Suo indirizzo email completo (es. info@suo-dominio.de)
- **Password:** la password della casella di posta da **Impostazioni → Email**

## 3. Connettere il telefono o il computer (IMAP e SMTP)

Per leggere e inviare email in **Apple Mail (iPhone, iPad, Mac)**, **Gmail / Android Mail**, **Outlook** o **Thunderbird**, aggiunga un nuovo account **IMAP** nella Sua app di posta elettronica e inserisca queste impostazioni del server:

| Impostazione | Valore |
| --- | --- |
| **Tipo di account** | IMAP |
| **Indirizzo email / Nome utente** | Il Suo indirizzo email completo (es. info@suo-dominio.de) |
| **Password** | La password della casella di posta da Impostazioni → Email |
| **Server posta in arrivo (IMAP)** | mail.tobysite.com |
| **Porta in arrivo** | 993 (SSL/TLS) |
| **Server posta in uscita (SMTP)** | mail.tobysite.com |
| **Porta in uscita** | 465 (SSL/TLS) o 587 (STARTTLS) |

> **Importante:** Si assicuri di inserire il Suo **indirizzo email completo** (incluso @suo-dominio.de) come nome utente per **entrambi** i server in arrivo (IMAP) e in uscita (SMTP).

### Passo dopo passo su iPhone e iPad (iOS Mail)

1. Apra l'app **Impostazioni** dell'iPhone → **App** → **Mail** → **Account Mail** → **Aggiungi account** → **Altro** → **Aggiungi account Mail**.
2. Inserisca il Suo nome, il Suo indirizzo email completo, la password della casella di posta e una breve descrizione. Tocchi **Avanti**.
3. Mantenga selezionato **IMAP** in alto.
4. Sotto **Server posta in arrivo** e **Server posta in uscita**, inserisca mail.tobysite.com come Nome host, il Suo indirizzo email completo come Nome utente e la password della casella di posta.
5. Tocchi **Avanti** e poi **Salva**.

### Passo dopo passo su Android (app Gmail)

1. Apra l'app **Gmail**, tocchi la Sua immagine del profilo in alto a destra → **Aggiungi un altro account** → **Altro**.
2. Inserisca il Suo indirizzo email completo e tocchi **Configurazione manuale** → **Personale (IMAP)**, poi inserisca la Sua password.
3. Per il **Server in arrivo**, imposti il server su mail.tobysite.com, porta 993 e tipo di sicurezza SSL/TLS.
4. Per il **Server SMTP in uscita**, imposti il server su mail.tobysite.com, porta 465 (SSL/TLS) e si assicuri che **Richiedi accesso** sia abilitato con il Suo indirizzo email completo.
5. Tocchi **Avanti** per terminare.

Successivo: [Newsletter e annunci](/it/docs/newsletter).
